/**
 * @generated SignedSource<<b469b252fe8dc4b906dc1a92bad40c08>>
 * @relayHash 21afd2bd4daf123d09dde0f01711592c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 642e553ab83b7c6dea08a11ef5fb8cd3492ed825205e7b7bc2ca2711aae652c9

import type { ConcreteRequest } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type ContentStateInput = {
  color?: string | null | undefined;
  id?: AGG$Long | null | undefined;
  name?: string | null | undefined;
  spaceKey?: string | null | undefined;
};
export type SuggestedContentStateCustomizationAreaCreateSpaceContentStateMutation$variables = {
  contentState: ContentStateInput;
};
export type SuggestedContentStateCustomizationAreaCreateSpaceContentStateMutation$data = {
  readonly createSpaceContentState: {
    readonly color: string;
    readonly id: string | null | undefined;
    readonly name: string;
    readonly restrictionLevel: ContentStateRestrictionLevel;
  } | null | undefined;
};
export type SuggestedContentStateCustomizationAreaCreateSpaceContentStateMutation = {
  response: SuggestedContentStateCustomizationAreaCreateSpaceContentStateMutation$data;
  variables: SuggestedContentStateCustomizationAreaCreateSpaceContentStateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentState"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentState",
        "variableName": "contentState"
      }
    ],
    "concreteType": "ContentState",
    "kind": "LinkedField",
    "name": "createSpaceContentState",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "color"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "restrictionLevel"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SuggestedContentStateCustomizationAreaCreateSpaceContentStateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SuggestedContentStateCustomizationAreaCreateSpaceContentStateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "21afd2bd4daf123d09dde0f01711592c",
    "id": "642e553ab83b7c6dea08a11ef5fb8cd3492ed825205e7b7bc2ca2711aae652c9",
    "metadata": {},
    "name": "SuggestedContentStateCustomizationAreaCreateSpaceContentStateMutation",
    "operationKind": "mutation",
    "text": "mutation SuggestedContentStateCustomizationAreaCreateSpaceContentStateMutation($contentState:ContentStateInput!){createSpaceContentState(contentState:$contentState){color,name,id,restrictionLevel}}"
  }
};
})();

(node as any).hash = "9a2564fc1c158ff5bb9b299dbe25c825";

export default node;
